import React from 'react';
import { Group, Paper, Text, ThemeIcon } from '@mantine/core';

import { When } from '../common';

const ACCENT_CLASS_BY_COLOR: Record<string, string> = {
    blue: 'bg-[var(--mantine-color-blue-6)]',
    indigo: 'bg-[var(--mantine-color-indigo-6)]',
    red: 'bg-[var(--mantine-color-red-6)]',
    gray: 'bg-[var(--mantine-color-gray-6)]',
    green: 'bg-[var(--mantine-color-green-6)]',
};

type PriceSyncStatCardProps = {
    label: string;
    value: number | string;
    color: string;
    icon: React.ReactNode;
    description?: string;
};

export function PriceSyncStatCard({
    label,
    value,
    color,
    icon,
    description,
}: PriceSyncStatCardProps) {
    const accentClass =
        ACCENT_CLASS_BY_COLOR[color] ?? ACCENT_CLASS_BY_COLOR.gray;

    return (
        <Paper
            p="lg"
            withBorder
            radius="lg"
            className="relative overflow-hidden"
        >
            <div
                className={`absolute top-0 left-0 h-full w-1 rounded-l-lg ${accentClass}`}
            />
            <Group gap="md" wrap="nowrap">
                <ThemeIcon size={44} radius="md" variant="light" color={color}>
                    {icon}
                </ThemeIcon>
                <div className="flex-1">
                    <Text size="xs" tt="uppercase" fw={600} c="dimmed" mb={2}>
                        {label}
                    </Text>
                    <Text size="xl" fw={700} lh={1}>
                        {typeof value === 'number'
                            ? value.toLocaleString()
                            : value}
                    </Text>
                    <When condition={Boolean(description)}>
                        <Text size="xs" c="dimmed" mt={4}>
                            {description}
                        </Text>
                    </When>
                </div>
            </Group>
        </Paper>
    );
}
